import { render } from "./ClientStoresPanel.vue?vue&type=template&id=5a98b1ba&scoped=true"
import script from "./ClientStoresPanel.vue?vue&type=script&lang=js"
export * from "./ClientStoresPanel.vue?vue&type=script&lang=js"

import "./ClientStoresPanel.vue?vue&type=style&index=0&id=5a98b1ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a98b1ba"]])

export default __exports__